import { render, staticRenderFns } from "./Ranking3.vue?vue&type=template&id=ea7d7f56"
import script from "./Ranking3.vue?vue&type=script&lang=js"
export * from "./Ranking3.vue?vue&type=script&lang=js"
import style0 from "./Ranking3.vue?vue&type=style&index=0&id=ea7d7f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports